import { graphql } from 'src/gql'
import { SortFindManyStaffingAgencyPocTypeInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query staffingAgencyPocTypes($sort: SortFindManyStaffingAgencyPocTypeInput) {
    lookups {
      StaffingAgencyPocType {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyPocTypes = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['StaffingAgencyPocType']>['many']>

const useStaffingAgencyPocTypes = useGraphQLDropdownOptions(
  document,
  'lookups.StaffingAgencyPocType.many',
  {
    sort: SortFindManyStaffingAgencyPocTypeInput.OrderAsc
  }
)

export { useStaffingAgencyPocTypes, document as staffingAgencyPocTypesDocument }
